<template>
    <v-dialog
        v-model="deleteRuleDialog"
        hide-overlay
        width="500"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                class="px-2 text-subtitle-2 float-right"
                outlined
                light
                v-bind="attrs"
                color="red darken-1"
                @click="openModel"
            >
                <v-icon
                    class="material-icons-outlined"
                >
                    delete
                </v-icon>
                Delete
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="text-h5 lighten-2">
                <span>Delete</span>
            </v-card-title>
            <v-divider />
            <v-card-text
                class="py-5"
                style="font-size: 16px"
            >
                Are you sure you want to delete "{{ ruleName }}" from the Auto-Assign Rules?
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn
                    outlined
                    light
                    @click="closedModel"
                >
                    Cancel
                </v-btn>
                <v-btn
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    @click="ruleDelete"
                >
                    Delete
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';

export default {
    props: {
        rowid: {
            type: String,
            required: false,
            default: ''
        },
        ruleName: {
            type: String,
            required: false,
            default: ''
        }
    },
    data: () => ({
        deleteRuleDialog: false
    }),
    methods: {
        closedModel() {
            this.deleteRuleDialog = false;
        },
        openModel() {
            this.deleteRuleDialog = true;
        },
        async ruleDelete() {
            let response = await webtmsBackend.deleteAutoAssignRule(this.rowid);
            if(response.result == 'OK') {
                this.$emit('reload-rules');
                this.closedModel();
            }
        }
    }
};
</script>
<style>
    #delete-image-container {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.0025em;
        color: var(--ll-text-primary);
        margin: 16px 0px;
    }
</style>
